const ITEMS = [
  "Strategy",
  "People",
  "Impact",
  "Higher Education",
  "Healthcare",
  "Real Estate",
  "Start-ups",
  "Family Business",
  "Growing Organisations",
  "Schools",
  "Trust",
  "Ideas",
  "Action",
  "Collaboration",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#0B2A5B]/10 bg-white/60 py-6 overflow-hidden select-none"
    >
      <div className="marquee-track items-center gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="f-display text-2xl sm:text-3xl text-[#0B2A5B]/85 px-8 whitespace-nowrap italic font-light">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#1E5FE0] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
